import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { useDeleteClients } from 'modules/crm/clients/hooks/useDeleteClients';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { IClients } from 'modules/crm/clients/interfaces';
import ClientResendConfirmationRowAction from './ClientResendConfirmationRowAction';

type UserStatusProps = {
  rowId: string;
  record: IClients;
};

const ClientsRowActions = ({ rowId, record }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const handleEdit = useParamsLink({ edit: rowId });
  const { mutate, isPending, error } = useDeleteClients(rowId, onClose);
  return (
    <>
      <Stack direction='row' spacing={1}>
        <ClientResendConfirmationRowAction email={record?.email} verified={record?.security?.verified} />
        <EditRowActions onClick={handleEdit} />
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
        />
      </Stack>
    </>
  );
};

export default memo(ClientsRowActions);
